export const comingSoonInit = () => {
    const target = document.querySelector(".comingSoon__figure");
    const section = document.querySelector(".comingSoon");

    if (target && section) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        target.classList.add("is-active");
                        observer.unobserve(section);
                    }
                });
            },
            {
                threshold: 0.5,
            }
        );

        observer.observe(section);
    }
};
